var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useState } from 'react';
import { useToggle } from '@hn-front/utils';
import { styled, css } from 'styled-components';
import { DeleteButton, CancelButton, DeleteButtonWithTooltip, EditButton, PrintButton, ConfirmButton, } from '../../Buttons';
import { classLinkText, cleverText, } from '../../Common';
import { Container, Cell, MainTextField, ExtraTextFieldContainer, ExtraTextField, EditContainer, ButtonsCell, ConfirmationButtonsContainer, } from '../Common';
import { DeleteModal } from '../Modals/DeleteModal';
import { getPrintStudentUrl } from '../../api';
import { Tooltip } from '@hn-ui/tooltips';
var MAX_NAME_LENGTH = 35;
var MAX_PASSWORD_LENGTH = 30;
var editTooltipText = {
    clever: cleverText,
    classLink: classLinkText,
    manual: undefined,
};
var StudentContainer = styled(Container).withConfig({ displayName: "StudentContainer", componentId: "sc-94ik1y" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, recovered = _a.recovered;
    var color = theme.colors.darkBlue95;
    if (recovered) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &&& {\n          background: ", ";\n        }\n      "], ["\n        &&& {\n          background: ", ";\n        }\n      "])), color);
    }
    return null;
});
var StudentRow = function (_a) {
    var groupId = _a.groupId, index = _a.index, student = _a.student, onEditStart = _a.onEditStart, onDelete = _a.onDelete, tooltipText = _a.tooltipText, isRecovered = _a.isRecovered;
    var id = student.id, name = student.name, password = student.password;
    var _b = useToggle(), shouldShowModal = _b.isToggled, toggleModal = _b.toggle;
    var handleOnDelete = function () {
        toggleModal();
        onDelete(id);
    };
    var url = getPrintStudentUrl(groupId, id);
    var modalInfo = "Are you sure you want to delete " + name + "?";
    return (_jsxs(_Fragment, { children: [_jsxs(StudentContainer, __assign({ recovered: isRecovered }, { children: [_jsx(Cell, { children: index }, void 0), _jsx(Cell, { children: name.length > MAX_NAME_LENGTH ? (_jsx(Tooltip, __assign({ content: name, maxWidth: 320 }, { children: _jsxs("span", { children: [name.substring(0, MAX_NAME_LENGTH), "..."] }, void 0) }), void 0)) : (name) }, void 0), _jsx(Cell, { children: password.length > MAX_PASSWORD_LENGTH ? (_jsx(Tooltip, __assign({ content: password, maxWidth: 320 }, { children: _jsxs("span", { children: [password.substring(0, MAX_PASSWORD_LENGTH), "..."] }, void 0) }), void 0)) : (password) }, void 0), _jsxs(ButtonsCell, { children: [_jsx(EditButton, { onClick: onEditStart }, void 0), _jsx(PrintButton, { url: url }, void 0), tooltipText ? (_jsx(DeleteButtonWithTooltip, { tooltipText: tooltipText }, void 0)) : (_jsx(DeleteButton, { onClick: toggleModal }, void 0))] }, void 0)] }), void 0), _jsx(DeleteModal, { size: 's', isOpen: shouldShowModal, onClose: toggleModal, title: 'Delete student', info: modalInfo, onDelete: handleOnDelete }, void 0)] }, void 0));
};
var EditStudentRow = function (_a) {
    var index = _a.index, student = _a.student, onSave = _a.onSave, onCancel = _a.onCancel, shouldUpdateName = _a.shouldUpdateName;
    var id = student.id, defaultName = student.name, defaultPassword = student.password;
    var _b = useState(defaultName), name = _b[0], setName = _b[1];
    var _c = useState(defaultPassword), password = _c[0], setPassword = _c[1];
    var handleOnNameChange = function (event) {
        setName(event.currentTarget.value);
    };
    var handleOnPasswordChange = function (event) {
        setPassword(event.currentTarget.value);
    };
    var handleOnSave = function () {
        return onSave({
            id: id,
            name: shouldUpdateName ? name : null,
            password: password,
        });
    };
    var hasEmptyFields = password.length === 0 || (shouldUpdateName && name.length === 0);
    return (_jsxs(EditContainer, { children: [_jsx(Cell, { children: index }, void 0), _jsx(Cell, { children: shouldUpdateName ? (_jsx(MainTextField, { value: name, onChange: handleOnNameChange, placeholder: 'Student Name' }, void 0)) : (name) }, void 0), _jsxs(Cell, { children: [_jsx(ExtraTextFieldContainer, { children: _jsx(ExtraTextField, { value: password, onChange: handleOnPasswordChange, placeholder: 'Password' }, void 0) }, void 0), _jsxs(ConfirmationButtonsContainer, { children: [_jsx(ConfirmButton, { title: 'Save', onClick: handleOnSave, disabled: hasEmptyFields }, void 0), _jsx(CancelButton, { title: 'Cancel', onClick: onCancel }, void 0)] }, void 0)] }, void 0)] }, void 0));
};
var Row = memo(function (_a) {
    var groupType = _a.groupType, groupId = _a.groupId, index = _a.index, student = _a.student, onUpdate = _a.onUpdate, onDelete = _a.onDelete, isRecovered = _a.isRecovered;
    var _b = useToggle(), isInEditMode = _b.isToggled, toggleEditMode = _b.toggle;
    var handleOnSave = function (data) {
        onUpdate(data);
        toggleEditMode();
    };
    return isInEditMode ? (_jsx(EditStudentRow, { index: index, student: student, onSave: handleOnSave, onCancel: toggleEditMode, shouldUpdateName: groupType === 'manual' }, void 0)) : (_jsx(StudentRow, { isRecovered: isRecovered, groupId: groupId, index: index, student: student, onEditStart: toggleEditMode, onDelete: onDelete, tooltipText: editTooltipText[groupType] }, void 0));
});
export { Row as StudentRow };
var templateObject_1, templateObject_2;
